
let baseUrl = import.meta.env.VITE_APP_API_URL + 'api/v1';
let backend_url = import.meta.env.VITE_APP_API_URL;
const urls = {
    server: baseUrl,
    delete_record: baseUrl,

    get_csrf: backend_url + 'sanctum/csrf-cookie',


    //Store APIS
    get_store_meta_data: baseUrl + '/store/meta-data',
    get_active_collections: baseUrl + '/store/collections/active',
    get_products_by_collection: baseUrl + '/store/products/collection',
    get_product_full_details: baseUrl + '/store/products/get-product-full-details',
    add_item_to_cart: baseUrl + '/store/cart/add-item',
    get_user_cart: baseUrl + '/store/user/cart',
    get_cart_count: baseUrl + '/store/cart/count',
    remove_item_from_cart: baseUrl + '/store/cart/remove-item',
    get_shipping_cost: baseUrl + '/store/shipping-cost',
    checkout_cart: baseUrl + '/store/checkout-cart',
    get_store_products: baseUrl + '/store/products',
    get_product_active_variations: baseUrl + '/store/get-active-product-variations',
    get_store_filters: baseUrl + '/store/get-filters',
    get_store_collections: baseUrl + '/store/get-collections',
    get_app_currencies: baseUrl + '/store/app-currencies',
    get_payment_status: baseUrl + '/store/payment-status',
    get_retry_payment_link: baseUrl + '/store/get-retry-payment-link',




    //End Store APIS



    //User APIS
    login_url: baseUrl + '/auth/login',
    register_user: baseUrl + '/auth/register-user',
    logout_url: baseUrl + '/auth/logout',
    get_user: baseUrl + '/auth/user',
    self_update_user: baseUrl + '/auth/users/self-update',
    //End User APIS

    get_all_brands: baseUrl + '/auth/brands',
    create_brand: baseUrl + '/auth/brands/create',
    update_brand: baseUrl + '/auth/brands/update',

    get_all_categories: baseUrl + '/auth/categories',
    create_category: baseUrl + '/auth/categories/create',
    edit_category: baseUrl + '/auth/categories/update',

    get_all_users: baseUrl + '/auth/users',
    create_user: baseUrl + '/auth/users/create',
    edit_user: baseUrl + '/auth/users/update',

    get_all_currencies: baseUrl + '/auth/currencies',
    create_currency: baseUrl + '/auth/currencies/create',
    update_currency: baseUrl + '/auth/currencies/update',


    get_all_shipping_zones: baseUrl + '/auth/shipping-zones',
    save_shipping_zone: baseUrl + '/auth/shipping-zones/create',
    update_shipping_zone: baseUrl + '/auth/shipping-zones/update',
    upadte_shipping_settings: baseUrl + '/auth/shipping-settings/update',


    get_all_product_attributes: baseUrl + '/auth/product-attributes',
    get_active_product_attributes: baseUrl + '/auth/product-attributes/active',
    save_product_attribute: baseUrl + '/auth/product-attributes/create',
    update_product_attribute: baseUrl + '/auth/product-attributes/update',


    get_product_attribute_values: baseUrl + '/auth/product-attribute-values',
    save_product_attribute_value: baseUrl + '/auth/product-attribute-value/create',
    update_product_attribute_value: baseUrl + '/auth/product-attribute-value/update',

    get_all_units: baseUrl + '/auth/units',
    save_unit: baseUrl + '/auth/units/create',
    update_unit: baseUrl + '/auth/units/update',

    get_product_form_data: baseUrl + '/auth/products/form-data',
    save_product: baseUrl + '/auth/products/create',
    update_product: baseUrl + '/auth/products/update',
    update_product_images: baseUrl + '/auth/products/update-images',

    get_all_products: baseUrl + '/auth/products',
    search_products_strictly: baseUrl + '/auth/products/search/strictly',
    update_product_settings: baseUrl + '/auth/products/settings/update',

    get_all_collections: baseUrl + '/auth/collections',
    save_collection: baseUrl + '/auth/collections/create',
    update_collection: baseUrl + '/auth/collections/update',
    update_products_in_collection: baseUrl + '/auth/collections/update-products',

    get_all_banners: baseUrl + '/auth/banners',
    save_banner: baseUrl + '/auth/banners/create',
    update_banner: baseUrl + '/auth/banners/update',

    get_all_product_fields: baseUrl + '/auth/products-fields',
    save_product_field: baseUrl + '/auth/products-fields/create',
    update_product_field: baseUrl + '/auth/products-fields/update',

    get_all_active_sales: baseUrl + '/auth/sales/active',

    get_all_product_variations: baseUrl + '/auth/get-all-product-variations',
    get_product_variation_types: baseUrl + '/auth/get-product-variation-types',
    add_product_variation: baseUrl + '/auth/add-product-variation',
    update_product_variation: baseUrl + '/auth/update-product-variation',

    update_store_data: baseUrl + '/auth/update-store-data',
    get_sale_details: baseUrl + '/auth/sales/by-id',






}

export default urls;